import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';
import axios from '../axios.js';
import moment from 'moment/moment';
import Navbar from './Supportingfiles/navbar';
import Sidebar from './Supportingfiles/sidebar';

import './Resources/dashboard.css';


function SP_edit_production(){

  


   //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logtype=sessionStorage.getItem("logType00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");
 const busyid=sessionStorage.getItem("BusyId00");
 const counterid=sessionStorage.getItem("CounterId00");
 const production_id=sessionStorage.getItem("ProductionId00");


 //Checking if Sessions are Set

// alert(logstatus,loguser,logadminid);
 //Sessions Not Set
 {/*if(((logstatus==null)||(logstatus==""))||((logid==null)||(logid==""))||((token==null)||(token==" "))||((busyid==null)||(busyid==" "))||((counterid==null)||(counterid==" "))){
  
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("BusyName00");
   sessionStorage.removeItem("CounterId00");
   
 
    window.location.replace("/businesstools-login");
   }
  
   //Sessions Set
   else{
   */}


    
      
//Variables
const[Tbanks,setTbanks] = useState([]);//SetData Variable

//Error Variable
const[errorvar,seterrorvar] = useState();

//date
const[date,setdate]=useState();const updatedate = (event) => { setdate(event.target.value);}; const[date_er,setdate_er]=useState();
//type
const[type,settype]=useState();const updatetype = (event) => { settype(event.target.value); }; const[type_er,settype_er]=useState();
//particular
const[particular,setparticular]=useState();const updateparticular = (event) => { setparticular(event.target.value);}; const[particular_er,setparticular_er]=useState();
//cane_purchase_inqtl
const[cane_purchase_inqtl,setcane_purchase_inqtl]=useState(0);const updatecane_purchase_inqtl = (event) => { setcane_purchase_inqtl(event.target.value);}; const[cane_purchase_inqtl_er,setcane_purchase_inqtl_er]=useState();
//cane_crushed_inqtl
const[cane_crushed_inqtl,setcane_crushed_inqtl]=useState(0);const updatecane_crushed_inqtl = (event) => { setcane_crushed_inqtl(event.target.value);}; const[cane_crushed_inqtl_er,setcane_crushed_inqtl_er]=useState();
//sugar_s_inqtl
const[sugar_s_inqtl,setsugar_s_inqtl]=useState();const updatesugar_s_inqtl = (event) => { setsugar_s_inqtl(event.target.value);}; const[sugar_s_inqtl_er,setsugar_s_inqtl_er]=useState();
//sugar_s30_inqtl
const[sugar_s30_inqtl,setsugar_s30_inqtl]=useState();const updatesugar_s30_inqtl = (event) => { setsugar_s30_inqtl(event.target.value);}; const[sugar_s30_inqtl_er,setsugar_s30_inqtl_er]=useState();
//sugar_m_inqtl
const[sugar_m_inqtl,setsugar_m_inqtl]=useState();const updatesugar_m_inqtl = (event) => { setsugar_m_inqtl(event.target.value);}; const[sugar_m_inqtl_er,setsugar_m_inqtl_er]=useState();
//sugar_m30_inqtl
const[sugar_m30_inqtl,setsugar_m30_inqtl]=useState();const updatesugar_m30_inqtl = (event) => { setsugar_m30_inqtl(event.target.value);}; const[sugar_m30_inqtl_er,setsugar_m30_inqtl_er]=useState();
//molas_inqtl
const[molas_inqtl,setmolas_inqtl]=useState();const updatemolas_inqtl = (event) => { setmolas_inqtl(event.target.value);}; const[molas_inqtl_er,setmolas_inqtl_er]=useState();
//pressmud_inqtl
const[pressmud_inqtl,setpressmud_inqtl]=useState();const updatepressmud_inqtl = (event) => { setpressmud_inqtl(event.target.value);}; const[pressmud_inqtl_er,setpressmud_inqtl_er]=useState();
//baggase_inqtl
const[baggase_inqtl,setbaggase_inqtl]=useState();const updatebaggase_inqtl = (event) => { setbaggase_inqtl(event.target.value);}; const[baggase_inqtl_er,setbaggase_inqtl_er]=useState();
//caneseed_inqtl
const[caneseed_inqtl,setcaneseed_inqtl]=useState();const updatecaneseed_inqtl = (event) => { setcaneseed_inqtl(event.target.value);}; const[caneseed_inqtl_er,setcaneseed_inqtl_er]=useState();
//bank_id
const[bank_id,setbank_id]=useState();const updatebank_id = (event) => { setbank_id(event.target.value);}; const[bank_id_er,setbank_id_er]=useState();
//sugar_ssuper_inqtl
const[sugar_ssuper_inqtl,setsugar_ssuper_inqtl]=useState();const updatesugar_ssuper_inqtl = (event) => { setsugar_ssuper_inqtl(event.target.value);}; const[sugar_ssuper_inqtl_er,setsugar_ssuper_inqtl_er]=useState();
//sugar_msuper_inqtl
const[sugar_msuper_inqtl,setsugar_msuper_inqtl]=useState();const updatesugar_msuper_inqtl = (event) => { setsugar_msuper_inqtl(event.target.value);}; const[sugar_msuper_inqtl_er,setsugar_msuper_inqtl_er]=useState();
//brownsugar_inqtl
const[brownsugar_inqtl,setbrownsugar_inqtl]=useState();const updatebrownsugar_inqtl = (event) => { setbrownsugar_inqtl(event.target.value);}; const[brownsugar_inqtl_er,setbrownsugar_inqtl_er]=useState();


//ERROR VARIABLES 
const[error_msg,seterror_msg]=useState();




useEffect(()=>{
   
  getData();
  
  },[])
 

  
    
  
//******************* GET GODOWNS DATA FUNCTION START  ********************//
function getData(){
 

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&(production_id>0)){
 
 
 axios.post("productiondetails", {
   Log_id:logid,
   Token:token,
   Sn_start :0,
   Sn_end :0,
   Sn_total :0,
   Sn_limit :0,
   Production_id:production_id,
 })
 .then((response) => {

   console.log(response.data);

  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("BusyId00");
     sessionStorage.removeItem("CounterId00");

     window.location.replace("businesstools-login");
  }
  //Success Data Fetched
  if(response.data.successvar==1){
   //Setting Data
   setTbanks(response.data.godowns);
   setdate(response.data.date);
   setbank_id(response.data.godown_id);
   setcane_purchase_inqtl(response.data.cane_purchase_inqtl);
   setcane_crushed_inqtl(response.data.cane_crushed_inqtl);
   setsugar_s_inqtl(response.data.sugar_s_inqtl);
   setsugar_m_inqtl(response.data.sugar_m_inqtl);
   setsugar_s30_inqtl(response.data.sugar_s30_inqtl);
   setsugar_m30_inqtl(response.data.sugar_m30_inqtl);
   setsugar_ssuper_inqtl(response.data.sugar_ssuper_inqtl);
   setsugar_msuper_inqtl(response.data.sugar_msuper_inqtl);
   setmolas_inqtl(response.data.molas_inqtl);
   setpressmud_inqtl(response.data.pressmud_inqtl);
   setbrownsugar_inqtl(response.data.brownsugar_inqtl);
   setcaneseed_inqtl(response.data.caneseed_inqtl);
   setbaggase_inqtl(response.data.baggase_inqtl);
   setparticular(response.data.particular);

  }
  //Cannot Fetch Data
  else{
   seterrorvar("Cannot Fetch Data !");
  }
 
 
 });
 
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("CounterId00");

   window.location.replace("businesstools-login");
 
  }
 
 }
  
 //******************* GET GODOWNS DATA FUNCTION END  ********************//

  
//******************* CREATE PRODUCTION FUNCTION START ********************//
function createstock(){

  //Setting Error Variables
setdate_er(" ");
setcane_purchase_inqtl_er(" ");setcane_crushed_inqtl_er(" ");setsugar_s_inqtl_er(" ");setsugar_s30_inqtl_er(" "); setsugar_m_inqtl_er(" ");setsugar_m30_inqtl_er(" ");
setmolas_inqtl_er(" "); setbaggase_inqtl_er(" ");setcaneseed_inqtl_er(" ");setpressmud_inqtl_er(" ");setsugar_ssuper_inqtl_er(" ");setsugar_msuper_inqtl_er(" ");setbrownsugar_inqtl_er(" ");
seterror_msg(" ");


  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){
 
        //disabling button
//    document.getElementById('emp-submit-btn').disabled = true; 

  const addBtn = document.getElementById("emp-submit-btn");
  addBtn.disabled = true;
  addBtn.innerText = "Processing..."; // optional
 
  axios.post("editproductiondetails", {
   Log_id:logid,
   Token:token,
   Date : moment(date).format('YYYY-MM-DD'),
   Cane_purchase_inqtl:cane_purchase_inqtl,
   Cane_crushed_inqtl:cane_crushed_inqtl,
   Sugar_s_inqtl:0,//sugar_s_inqtl,
   Sugar_s30_inqtl:sugar_s30_inqtl,
   Sugar_m_inqtl:0,//sugar_m_inqtl,
   Sugar_m30_inqtl:sugar_m30_inqtl,
   Sugar_ssuper_inqtl:sugar_ssuper_inqtl,
   Sugar_msuper_inqtl:sugar_msuper_inqtl,
   Brownsugar_inqtl:brownsugar_inqtl,
   Molas_inqtl:molas_inqtl,
   Baggase_inqtl:baggase_inqtl,
   Caneseed_inqtl:caneseed_inqtl,
   Pressmud_inqtl:pressmud_inqtl,
   Godown_id:document.getElementById("bank_id").value,
   Particular : particular,
  Production_id:production_id,
 })
 .then((response) => {
    
    // In case of network or server error
    addBtn.disabled = false;
    addBtn.innerText = "submit";


    //Transaction Limit Reached
    if(response.data.error==111){     seterror_msg(response.data.error_msg); return; }


  //Invalid Session
  else if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("BusyId00");
     sessionStorage.removeItem("BusyName00");
     sessionStorage.removeItem("CounterId00");

     window.location.replace("businesstools-login");
  }

   //Validation Errors
 else if(response.data.validatorerror){
  setdate_er(response.data.validatorerror.Date);

  setcane_purchase_inqtl_er(response.data.validatorerror.Cane_purchase_inqtl);
  setcane_crushed_inqtl_er(response.data.validatorerror.Cane_crushed_inqtl);
  setsugar_s_inqtl_er(response.data.validatorerror.Sugar_s_inqtl);
  setsugar_s30_inqtl_er(response.data.validatorerror.Sugar_s30_inqtl);
  setsugar_m_inqtl_er(response.data.validatorerror.Sugar_m_inqtl);
  setsugar_m30_inqtl_er(response.data.validatorerror.Sugar_m30_inqtl);
  setsugar_ssuper_inqtl_er(response.data.validatorerror.Sugar_ssuper_inqtl);
  setsugar_msuper_inqtl_er(response.data.validatorerror.Sugar_msuper_inqtl);
  setbrownsugar_inqtl_er(response.data.validatorerror.Brownsugar_inqtl);
  setmolas_inqtl_er(response.data.validatorerror.Molas_inqtl);
  setbaggase_inqtl_er(response.data.validatorerror.Baggase_inqtl);
  setcaneseed_inqtl_er(response.data.validatorerror.Caneseed_inqtl);
  setpressmud_inqtl_er(response.data.validatorerror.Pressmud_inqtl);
  seterror_msg("Cannot Add Transaction!"); 
}
//Invalid Entries
else if(response.data.error==102){ 
  
  setdate_er(response.data.date_er);
  setcane_purchase_inqtl_er(response.data.cane_purchase_inqtl_er);
  setcane_crushed_inqtl_er(response.data.cane_crushed_inqtl_er);
  setsugar_s_inqtl_er(response.data.sugar_s_inqtl_er);
  setsugar_s30_inqtl_er(response.data.sugar_s30_inqtl_er);
  setsugar_m_inqtl_er(response.data.sugar_m_inqtl_er);
  setsugar_m30_inqtl_er(response.data.sugar_m30_inqtl_er);
  setsugar_ssuper_inqtl_er(response.data.sugar_ssuper_inqtl_er);
  setsugar_msuper_inqtl_er(response.data.sugar_msuper_inqtl_er);
  setbrownsugar_inqtl_er(response.data.brownsugar_inqtl_er);
  setmolas_inqtl_er(response.data.molas_inqtl_er);
  setbaggase_inqtl_er(response.data.baggase_inqtl_er);
  setcaneseed_inqtl_er(response.data.caneseed_inqtl_er);
  setpressmud_inqtl_er(response.data.pressmud_inqtl_er);
  setparticular_er(response.data.particular_er);

  seterror_msg("Cannot Add Transaction!");  }


  //Invalid Entries
  else if(response.data.error==103){     seterror_msg(response.data.error_msg);  }

   //Transaction Entered Successfully
   else if(response.data.successvar==1){        document.getElementById("edit-success-card").style.display="block";  }
   //Cannot Add Transaction
   else{  seterror_msg("Cannot Add Transaction !"); }
  

});
}
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("BusyName00");
   sessionStorage.removeItem("CounterId00");

   window.location.replace("businesstools-login");
 
  }
 
 }
  
 //******************* CREATE PRODUCTION FUNCTION END ********************//



return(
    <>

    <html lang="en">
      <head>
        {/*} Required meta tags */}
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <title>React App</title>
        {/*} plugins:css */}
        <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
        <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
        <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
        {/*} endinject */}
        {/*} Plugin css for this page */}
        <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
        <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
        {/*} End plugin css for this page */}
        {/*} inject:css */}
        {/*} endinject */}
        {/*} Layout styles */}
        <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
        {/*} End layout styles */}
        <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
      </head>
      <body>
        <div class="container-scroller">
    
          <Sidebar />
        <div class="container-fluid page-body-wrapper">
    
    
           <Navbar />
            {/*} partial */}
            <div class="main-panel">
    
          
    
                  {/* EDIT SUCCESS CARD START */}
                 <div class="d-flex justify-content-center">
                 <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="edit-success-card">
                    <div class="card">
                      <div class="card-body">
                        <h4 class="card-title  text-success">Transaction Updated Successfully !!!</h4>
                      
                        <blockquote class="blockquote">
                          <p class="mb-0"> Click the following button to close.</p>
                          <button class="mt-3 btn btn-outline-danger" onClick={()=>{ window.location.replace("/spadminpanel-dashboard-production"); /*document.getElementById("edit-success-card").style.display="none";*/ }}>Close</button>
                        </blockquote>
                      </div>
                  
                    </div>
                  </div>
                  </div>
                  {/* EDIT SUCCESS CARD END */}
                   {/* EDIT ERROR CARD START */}
                <div class="d-flex justify-content-center">
                <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="edit-error-card">
                    <div class="card">
                      <div class="card-body">
                        <h4 class="card-title  text-danger">Cannot Fetch Data !!!</h4>
                      
                        <blockquote class="blockquote">
                          <p class="mb-0"> Click the following button to close.</p>
                          <button class="mt-3 btn btn-outline-danger" onClick={()=>{ document.getElementById("edit-error-card").style.display="none"; }}>Close</button>
                        </blockquote>
                      </div>
                  
                    </div>
                  </div>
                  </div>
                  {/* EDIT ERROR CARD END */}

                   <div class="content-wrapper pb-0">
       
            

            <div class="page-header flex-wrap">
            <div class="header-left"></div>
              <div class="header-right d-flex flex-wrap mt-2 mt-sm-0">
                <div class="d-flex align-items-center">
                  <a href="#">
                    <p class="m-0 pe-3">Production | Edit</p>
                  </a>
                  <a class="ps-3 me-4" href="#">
                  {/*}  <p class="m-0">ADE-00234</p> */}
                  </a>
                </div>
              

              </div>
            </div>
    
                <div class="card">
              
                  <div class="card-body">
                    <h4 class="card-title">Production Transaction</h4>
                    <div class="form-sample">
                      <p class="card-description">enter your production transactions here</p>
                      <code>{error_msg}</code>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Production Date<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="date" class="form-control" id="date" value={date} onChange={updatedate} />
                              <code>{date_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Select Godown<code>*</code></label>
                            <div class="col-sm-9">
                              <select class="form-control" placeholder="Select Godown" style={{padding:"1rem"}} id="bank_id" value={bank_id} onChange={updatebank_id}>
                              <option value="">Select Godown</option>
                              {
                              Tbanks.map((curElm2,ind)=>{

                              return(
                              <>
                              <option value={curElm2.GD_id}>{curElm2.Godown_name}</option>
                              </>
                              )
                              }
                       
                                    )
                              }
                              </select>
                              <code>{bank_id_er}</code>
                            </div>
                          </div>
                        </div>     
                      </div>
                     
                      <div class="row">
                          <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Cane Purchase (in Qtl)<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="3000.00" id="cane_purchase_inqtl" value={cane_purchase_inqtl} onChange={updatecane_purchase_inqtl} />
                              <code>{cane_purchase_inqtl_er}</code>
                            </div>
                          </div>
                      </div>
                       <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Cane Crushed (in Qtl)<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="2000.00" id="cane_crushed_inqtl" value={cane_crushed_inqtl} onChange={updatecane_crushed_inqtl} />
                              <code>{cane_crushed_inqtl_er}</code>
                            </div>
                          </div>
                      </div>
                      </div>
                       {/*} <div class="row">
                          <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Prod. Sugar S (in Qtl)<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="3000.00" id="sugar_s_inqtl" value={sugar_s_inqtl} onChange={updatesugar_s_inqtl} />
                              <code>{sugar_s_inqtl_er}</code>
                            </div>
                          </div>
                      </div>
                       <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Prod. Sugar M (in Qtl)<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="2000.00" id="sugar_m_inqtl" value={sugar_m_inqtl} onChange={updatesugar_m_inqtl} />
                              <code>{sugar_m_inqtl_er}</code>
                            </div>
                          </div>
                      </div>
                      </div>*/}
                      <div class="row">
                          <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Prod. Sugar S Super (in Qtl)<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="3000.00" id="sugar_ssuper_inqtl" value={sugar_ssuper_inqtl} onChange={updatesugar_ssuper_inqtl} />
                              <code>{sugar_ssuper_inqtl_er}</code>
                            </div>
                          </div>
                      </div>
                       <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Prod. Sugar M Super (in Qtl)<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="2000.00" id="sugar_msuper_inqtl" value={sugar_msuper_inqtl} onChange={updatesugar_msuper_inqtl} />
                              <code>{sugar_msuper_inqtl_er}</code>
                            </div>
                          </div>
                      </div>
                      </div>
                       <div class="row">
                          <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Prod. Sugar S30 (in Qtl)<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="3000.00" id="sugar_s30_inqtl" value={sugar_s30_inqtl} onChange={updatesugar_s30_inqtl} />
                              <code>{sugar_s30_inqtl_er}</code>
                            </div>
                          </div>
                      </div>
                       <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Prod. Sugar M30 (in Qtl)<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="2000.00" id="sugar_m30_inqtl" value={sugar_m30_inqtl} onChange={updatesugar_m30_inqtl} />
                              <code>{sugar_m30_inqtl_er}</code>
                            </div>
                          </div>
                      </div>
                      </div>
                       <div class="row">
                          <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Prod. Molasis (in Qtl)<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="3000.00" id="molas_inqtl" value={molas_inqtl} onChange={updatemolas_inqtl} />
                              <code>{molas_inqtl_er}</code>
                            </div>
                          </div>
                      </div>
                       <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Prod. Pressmud (in Qtl)<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="2000.00" id="pressmud_inqtl" value={pressmud_inqtl} onChange={updatepressmud_inqtl} />
                              <code>{pressmud_inqtl_er}</code>
                            </div>
                          </div>
                      </div>
                      </div>
                       <div class="row">
                          <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Prod. Baggase (in Qtl)<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="3000.00" id="baggase_inqtl" value={baggase_inqtl} onChange={updatebaggase_inqtl} />
                              <code>{baggase_inqtl_er}</code>
                            </div>
                          </div>
                      </div>
                       <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Prod. Caneseed (in Qtl)<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="2000.00" id="caneseed_inqtl" value={caneseed_inqtl} onChange={updatecaneseed_inqtl} />
                              <code>{caneseed_inqtl_er}</code>
                            </div>
                          </div>
                      </div>
                      </div>
                       <div class="row">
                          <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Brown Sugar (in Qtl)<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="3000.00" id="brownsugar_inqtl" value={brownsugar_inqtl} onChange={updatebrownsugar_inqtl} />
                              <code>{brownsugar_inqtl_er}</code>
                            </div>
                          </div>
                      </div>
                      </div>


                      <div class="form-group" style={{textAlign:"left"}}>
                        <label for="exampleTextarea1">Particular<code>*</code></label>
                        <textarea class="form-control" rows="2" id="particular" value={particular} onChange={updateparticular} ></textarea>
                        <code>{particular_er}</code>
                      </div>
                     
                        
                      
                        <button class="btn btn-primary" style={{fontWeight:"bold"}} id="emp-submit-btn" onClick={createstock}>Submit</button>
                      
  
                     
                   
                    </div>
                  </div>
                </div>

                

            
          </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
        {/*}  <footer class="footer">
            <div class="d-sm-flex justify-content-center justify-content-sm-between">
              <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2023 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i class="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
    </>

);

}
//}

export default SP_edit_production;